module.exports = __webpack_public_path__ + "img/undraw_3.f72e45ea.png";